// Transport DTOs — Generación de conceptos de cortes mensuales (ASIS-4969)

// POST /v1/monthlycuts/concept-generation
export interface LC_StartConceptGenerationIn {
  monthlyCutIds: number[];
  employeeIds?: string;        // CSV "1,2,3"; coincide con string? del backend
}

export interface LC_StartConceptGenerationOut {
  jobId: string;               // Guid serializado
  status: string;
  queuedCutIds: number[];
  skippedCutIds: number[];
  notFoundCutIds: number[];
  alreadyActiveCutIds: number[];  // cortes Abiertos omitidos por tener ya una generación en curso
}

// GET /v1/monthlycuts/{monthlyCutId}/concept-generation/progress
export interface LC_GetConceptGenerationProgressOut {
  monthlyCutId: number;
  progressPercentage: number;
  totalBatches: number;
  completedBatches: number;
  isActive: boolean;
  isCompleted: boolean;
  hasError: boolean;
  errorMessage?: string;       // coincide con string? del backend
  startedAt?: string;          // ISO 8601; coincide con DateTime?
  completedAt?: string;        // ISO 8601; coincide con DateTime?
}

// --- Modelo de dominio para la UI (fila/celda de acciones) ---
export interface ConceptGenerationProgress {
  monthlyCutId: number;
  progressPercentage: number;
  isActive: boolean;
  isCompleted: boolean;
  hasError: boolean;
  errorMessage: string | null;
}

// Entrada de dominio para iniciar la generación desde la UI.
// employeeIds opcional: si se omite, aplica a todos los colaboradores de cada corte.
export interface StartConceptGenerationInput {
  monthlyCutIds: number[];
  employeeIds?: number[];
}

// Código de error backend (HTTP 409) cuando el corte ya tiene una generación en curso.
// Centralizado en la capa de dominio API para no duplicar el literal en los hooks/vistas.
export const CONCEPT_GENERATION_ACTIVE_CONFLICT_CODE = 'CONFLICT_CONCEPT_GENERATION_ACTIVE';
